import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  LayoutDashboard, BookOpen, Users, UserCheck, ClipboardCheck,
  Scale, Star, Settings, Tag, ShieldCheck,
} from 'lucide-react';

/**
 * Barra de navegación de la sección de Administración.
 * Portada desde producción y adaptada a las rutas reales de esta rama
 * (incluye /admin/servicios, que es propio de este repo) y a i18n.
 */
export default function AdminTabs() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: t('common.dashboard', 'Panel'),            path: '/admin/dashboard',    Icon: LayoutDashboard },
    { label: t('admin.bookingsTab', 'Reservas'),        path: '/admin/bookings',     Icon: BookOpen },
    { label: t('admin.users', 'Usuarios'),              path: '/admin/users',        Icon: Users },
    { label: t('admin.kycTab', 'KYC'),                  path: '/admin/clients/kyc',  Icon: ShieldCheck },
    { label: t('admin.verifyLabel', 'Proveedores'),     path: '/admin/verification', Icon: UserCheck },
    { label: t('admin.servicesLabel', 'Servicios'),     path: '/admin/servicios',    Icon: ClipboardCheck },
    { label: t('admin.disputesLabel', 'Disputas'),      path: '/admin/disputes',     Icon: Scale },
    { label: t('admin.reviewsLabel', 'Reseñas'),        path: '/admin/reviews',      Icon: Star },
    { label: t('admin.commissionsLabel', 'Comisiones'), path: '/admin/commission',   Icon: Settings },
    { label: t('admin.categoriesLabel', 'Categorías'),  path: '/admin/categories',   Icon: Tag },
  ];

  return (
    <div className="border-b bg-white sticky top-[64px] z-30 shadow-sm">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex overflow-x-auto gap-1 py-2 hide-scrollbar">
          {tabs.map(({ label, path, Icon }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm whitespace-nowrap font-medium transition-all flex-shrink-0 active:opacity-75 ${
                  active
                    ? 'bg-[#134168] text-white shadow-sm'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
